import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, thirdWidth } from "../../blocks/layout/columnSpans";

/** The organisation's first setup, submitted once. The sitemap is edited later on /sitemap. */
export const quickStartPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "quickstart",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 12, mobile: 12 },
          // Each column is its card, so the two can match heights.
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-company-details",
              title: "Company Details",
              fields: [
                {
                  id: "field-name",
                  type: "text",
                  name: "name",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  span: thirdWidth,
                },
                {
                  id: "field-cityName",
                  type: "text",
                  name: "cityName",
                  label: "City",
                  required: true,
                  helpText: "The city in which the company is located.",
                  span: thirdWidth,
                },
                {
                  id: "field-regionName",
                  type: "text",
                  name: "regionName",
                  label: "Region",
                  required: true,
                  helpText: "The region/county in which the company is located.",
                  span: thirdWidth,
                },
                {
                  id: "field-companyWebsite",
                  type: "text",
                  name: "companyWebsite",
                  label: "Website URL",
                  required: true,
                  helpText:
                    "The URL of the company website e.g. https://www.green4solutions.com",
                  span: thirdWidth,
                },
                {
                  id: "field-customerReferenceFormat",
                  type: "text",
                  name: "customerReferenceFormat",
                  label: "Customer Reference Format",
                  required: true,
                  helpText:
                    "The customer reference format, where {0} will be substituted for the next number. For example, use 'M-{0}' for a customer reference like M-1000000",
                  span: thirdWidth,
                },
                {
                  id: "field-customerReferenceStart",
                  type: "number",
                  name: "customerReferenceStart",
                  label: "Customer Reference Starting Number",
                  required: true,
                  helpText:
                    "The starting number for the customer reference. This value will be incremented for each customer.",
                  span: thirdWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 12, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-email-marketing",
              title: "Email Marketing",
              fields: [
                {
                  id: "field-ecommsAgentId",
                  type: "text",
                  name: "ecommsAgentId",
                  label: "Agent Id",
                  span: fullWidth,
                },
                {
                  id: "field-ecommsActivationCode",
                  type: "text",
                  name: "ecommsActivationCode",
                  label: "Activation Code",
                  span: fullWidth,
                },
                {
                  id: "field-g4c_customerid",
                  type: "text",
                  name: "g4c_customerid",
                  label: "Customer Id",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
